import { useAdminCreateExerciseLibraryAsset } from "./useAdminCreateExerciseLibraryAsset";
import { useAdminUpdateExerciseLibraryAsset } from "./useAdminUpdateExerciseLibraryAsset";
import {
  Exercise,
  Options,
} from "../../exercise-library/hooks/useSaveExerciseLibraryAsset";

export function useAdminSaveExerciseLibraryAsset(createNewAsset: boolean) {
  const { mutate: createAsset } = useAdminCreateExerciseLibraryAsset();
  const { mutate: updateAsset } = useAdminUpdateExerciseLibraryAsset();
  return (
    { id, exercise, bodyparts, movementPatterns }: Exercise,
    options?: Options,
  ) => {
    const content = JSON.stringify(exercise);
    return createNewAsset
      ? createAsset(
          {
            name: exercise.title,
            content,
            bodyparts,
            movementPatterns,
          },
          {
            onSuccess: () => {
              if (options.onCompleted) {
                options.onCompleted();
              }
            },
          },
        )
      : updateAsset(
          {
            id,
            name: exercise.title,
            content,
            bodyparts,
            movementPatterns,
          },
          {
            onSuccess: () => {
              if (options.onCompleted) {
                options.onCompleted();
              }
            },
          },
        );
  };
}
